import script from "./DocumentEngineContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentEngineContainer.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentEngineContainer.vue?vue&type=style&index=0&id=24d543a5&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24d543a5"]])

export default __exports__